import { css } from 'styled-components';
import colors from 'src/constants/styles/colors';

export type ButtonVariant = 'filled' | 'outlined' | 'plain';

export interface ButtonLikeStyleProps {
    variant?: ButtonVariant;
    disabled?: boolean;
}

export const buttonLikeStyles = css<ButtonLikeStyleProps>`
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 11px 36px;
    border-radius: 8px;
    border: 1px solid ${(p) => (p.variant === 'outlined' ? colors.orange : 'transparent')};
    background-color: ${(p) => (p.variant === 'filled' ? colors.orange : 'transparent')};
    color: ${(p) =>
        p.variant === 'plain' ? '#000' : p.variant === 'outlined' ? colors.orange : colors.gray_90};

    cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};
    pointer-events: ${(p) => (p.disabled ? 'none' : 'auto')};
`;

export const buttonLikeTextStyles = css`
    color: inherit;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    letter-spacing: 0.01em;
    margin: 0;
`;
